import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {classMap} from 'lit/directives/class-map.js';
import {connect} from 'pwa-helpers';
import {msg} from '@lit/localize';
import {when} from 'lit/directives/when.js';
import store from '../../../store';
import {selectShowPersonalisation} from '../../../selectors';

@customElement('line-specsheet')
export class LineSpecsheet extends connect(store)(LitElement) {

	static styles = [
		css`
			:host {
				container-type: inline-size;
			}

			@media screen {
				.page {
					max-width: 1400px;
					width: 90%;
					box-sizing: border-box;
					margin: 40px auto 20px auto;
					box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.25);
				}
			}
			@media print {
				.page {
					margin: 0;
					box-shadow: none;
				}
			}
        `
	];
	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.print = state.status.media === 'print' || status.media === 'print2';
		this.showPersonalisation = selectShowPersonalisation(state);
	}

	render() {
		return html`
			${when(this.showPersonalisation, () => html`
				<shared-specsheet-page title="Line" class="page ${classMap({print: this.print})}" headLabel="${msg('Personalisation')}">
					<personalise-form></personalise-form>
				</shared-specsheet-page>
			`)}
			<shared-specsheet-page title="Line" class="page ${classMap({print: this.print})}" headLabel="${msg('Specifications')}">
				<shared-technical-data-page></shared-technical-data-page>
			</shared-specsheet-page>
			<shared-specsheet-page title="Line" class="page ${classMap({print: this.print})}" headLabel="${msg('Product description')}">
				<shared-tender-text-page></shared-tender-text-page>
			</shared-specsheet-page>
			<shared-specsheet-page title="Line" class="page ${classMap({print: this.print})}" headLabel="${msg('Lighting technology')}">
				<shared-light-engine></shared-light-engine>
			</shared-specsheet-page>
		`;
	}
}
